import aa from 'search-insights';

/**
 * Algolia Insights API の初期化。
 * 匿名 userToken は `_ALGOLIA` Cookie に自動生成される。
 *
 * @see https://www.algolia.com/doc/guides/sending-events/getting-started
 */
export default defineNuxtPlugin(() => {
  const runtimeConfig = useRuntimeConfig();
  const appId = runtimeConfig.public.ALGOLIA_APP_ID as string;
  const apiKey = runtimeConfig.public.ALGOLIA_SEARCH_API_KEY as string;

  if (!appId || !apiKey) return;

  aa('init', { appId, apiKey, useCookie: true });
});
